import { compose, applyMiddleware, createStore } from "redux";
import { createLogger } from "redux-logger";
import createHistory from "history/createBrowserHistory";
import { routerMiddleware as createRouterMiddleware } from "react-router-redux";
import createSagaMiddleware from "redux-saga";
import { detectedLocation } from "sc/actions/ui/location";
import { persistStore, persistReducer } from "redux-persist";
import Navigation from "./helpers/navigation";
import ReduxSubmitter from "./helpers/redux-submit";

export const createConfig = environment => (
  createAppReducer,
  appSagas,
  persistConfig,
) => {
  const logger = createLogger({
    predicate: () =>
      process.env.NODE_ENV === "development" ||
      (process.env.NODE_ENV === "test" && process.env.DEBUG_TESTS),
    diff: true,
  });
  const history = createHistory();
  const routerMiddleware = createRouterMiddleware(history);
  const sagaMiddleware = createSagaMiddleware();
  const rootReducer = persistReducer(persistConfig, createAppReducer());
  const store = createStore(
    rootReducer,
    undefined,
    compose(applyMiddleware(logger, routerMiddleware, sagaMiddleware)),
  );
  const persistor = persistStore(store);
  Navigation.init(store.dispatch);
  ReduxSubmitter.init(store.dispatch);

  appSagas.forEach(saga => sagaMiddleware.run(saga));
  store.dispatch(detectedLocation(environment));
  return {
    store: store,
    history: history,
    persistor,
  };
};



// WEBPACK FOOTER //
// ./src/sc/config.js